export function GoStorySection() {
  return (
    <div className="mk-section">
      <div className="mk-container mk-text-center" style={{ maxWidth: 900 }}>
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/message.svg" alt="" />
          </span>
          Built by real people
        </span>

        <h2 className="mk-title" style={{ marginBottom: 0 }}>
          We built To To-Do because{" "}
          <span className="mk-title-accent">we needed it ourselves</span>
        </h2>
        <p className="mk-subtitle">
          Balancing family life, running businesses, and taking care of our own
          well-being was a daily challenge.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 24,
            maxWidth: 800,
            margin: "32px auto 0",
            textAlign: "left",
          }}
        >
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6 }}>
            We built it to manage the real-life juggle of family, work, and
            well-being. It's your simple yet powerful support when life feels
            overwhelming—helping you gather your thoughts, reorganize, and regain
            balance.
          </p>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6 }}>
            By offloading tasks and ideas from your mind, you get more focus,
            less stress, and the energy to actually get things done. To To-Do is
            your everyday safety net—always accessible, easy to use, and strong
            enough for more demanding projects.
          </p>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6 }}>
            Battle-tested in real life, and now available worldwide in over 20
            languages.
          </p>
        </div>
      </div>
    </div>
  )
}
